import { Skeleton } from '@mui/material';
import { ListItem } from 'shared/mui/List';

export const NotificationPopperSkeleton: React.FC = () => (
  <ListItem
    sx={{
      padding: '16px',
    }}
  >
    <Skeleton height={48} variant="rounded" width="100%" />
  </ListItem>
);
